import { render, staticRenderFns } from "./ModalCreateTest.vue?vue&type=template&id=b64fff4a&scoped=true"
import script from "./ModalCreateTest.vue?vue&type=script&lang=js"
export * from "./ModalCreateTest.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateTest.vue?vue&type=style&index=0&id=b64fff4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64fff4a",
  null
  
)

export default component.exports